import styled from 'styled-components';
import { COLORS } from '@stelecom/ui-react/assets/js/constants';
import { breakpoints } from '~/src/components/Header/styled';

export const MainMenuWrapper = styled.div<{
  isFixed: boolean;
  withHideItems?: boolean;
}>`
  position: relative;
  flex-wrap: nowrap;
  height: 100%;
  padding-right: 35px;
  overflow: ${(p) => (p.withHideItems ? 'hidden' : 'visible')};

  &:before {
    content: "";
    position: fixed;
    top: ${(p) => (p.isFixed ? '72px' : '112px')};
    left: 0;
    right: 0;
    background: ${COLORS.lightGrey};
    box-shadow: 0 8px 20px -2px rgba(41, 44, 48, 0.1);
    transform-origin: top center;
    transition: height 0.3s linear;
  }
  @media (max-width: ${breakpoints.sDesktop}) {
    padding-right: 0;
  }
`;

export const MainMenuInner = styled.div<{ withHideItems?: boolean }>`
  flex-wrap: nowrap;
  align-self: stretch;
  height: 100%;
  overflow: ${(p) => (p.withHideItems ? 'hidden' : 'visible')};
`;

export const ItemWrap = styled.div`
  &:not(:first-child) {
    padding-left: 12px;
  }

  &:not(:last-child) {
    padding-right: 12px;
  }
`;

export const DisplayBtn = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: auto;
  width: 20px;
  visibility: 0;
  cursor: pointer;
`;

export const Img = styled.img<{ isAllItemsView?: boolean }>`
  transform: rotate(${(p) => (p.isAllItemsView ? '0' : '180deg')});
  transition: all 0.3s ease;
`;
